<template>
   <svg name="exclamation-circle" viewBox="0 0 14 14" aria-hidden="true" focusable="false">
      <path
         d="M7 0C3.136 0 0 3.136 0 7C0 10.864 3.136 14 7 14C10.864 14 14 10.864 14 7C14 3.136 10.864 0 7 0ZM7.7 10.5H6.3V9.1H7.7V10.5ZM7.7 7.7H6.3V3.5H7.7V7.7Z"
         stroke-width="0"
      />
   </svg>
</template>

<script setup lang="ts"></script>

<style lang="scss" scoped></style>
